import { createBrowserHistory } from 'history';
import dataProvider from './dataProvider';
import authProvider from './coreWalletAuthProvider';
import { approvableAdminActionSaga } from './sagas';

import { Layout } from './layout';
import { Dashboard } from './dashboard';

const history = createBrowserHistory({
	basename: process.env.PUBLIC_URL
});

// Monkey-patch history.push to avoid propagation of filters into the query,
// because this would propagate back into any other list currently displayed.
// If you don't need this, you can create your own history (see the three lines
// above) and pass it into the <Admin> component.
const oldPush = history.push;
history.push = (path, state) => {
	if (typeof path === 'object') {
		oldPush({
			...path,
			search: null,
		});
	} else {
		oldPush(path, state && {
			...state,
			search: null,
		});
	}
};

export {
	dataProvider,
	authProvider,
	Layout,
	Dashboard,
	history,
	approvableAdminActionSaga,
};
